<template>
    <div class="form-dynamic-wrapper mb-2">
        <b-row class="pr-5">
            <b-col md="4">
                <b-form-group>
                    <label>Name</label>
                    <b-form-input v-model="spesifikasi.name" name="spesifikasiName" placeholder="Name" class="mr-2" required></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group>
                    <label>Short Name</label>
                    <b-form-input v-model="spesifikasi.shortName" name="spesifikasiShortName" placeholder="Short Name" class="mr-2" required></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group>
                    <label class="radio-label">
                       Persen
                    </label>
                    <b-input-group append="%">
                        <b-form-input v-model="spesifikasi.reduction" :id="`persenDesc-${spesifikasi.index}`" name="spesifikasireduction" step="0.01" type="number" @blur="roundPersen" :disabled="spesifikasi.detailInfo == 'nominal'" required></b-form-input>
                    </b-input-group>
                </b-form-group>
                <b-popover :target="`persenDesc-${spesifikasi.index}`" title="Catatan" triggers="focus">
                    <ul class="tooltip-content-wrapper list-popover-wrapper">
                        <li class="mb-2">
                            <span class="small-muted-persen">100%</span>  -> harga dasar (tidak ada penambahan maupun pengurangan)
                        </li>
                        <li class="mb-2">
                            <span class="small-muted-persen">110%</span>  -> Tambahan 10% dari harga barang
                        </li>
                        <li class="mb-0">
                            <span class="small-muted-persen">80%</span>  -> Potongan 20% dari harga barang
                        </li>
                    </ul>
                </b-popover>
            </b-col>
        </b-row>
        <div class="form-dynamic-deleteWrapper">
            <b-button class="btn-dynamicActiveBtn" name="aktifSpesifikasi" @click="$emit('aktif', spesifikasi.index)"><i class="fa fa-plus"></i></b-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'spesifikasi-non-aktif',
    props: {
        spesifikasi: { type: Object, required: true },
        length: { type: Number, required: true }
    },
    watch: {
        "spesifikasi.nominalAngka": function(newValue) {
            let cleanValue = this.$helper.changeToValue(newValue);
            const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.spesifikasi.nominalAngka = result);
        },
    },
    methods: {
        roundPersen(){
            var x = Number(this.spesifikasi.reduction).toFixed(2);
            this.spesifikasi.reduction = x;
        }
    }
}
</script>
